import faqs from 'lib/faqs';

import { FAQs } from '@frontendmentorio/design-system-v2';

FAQs.FAQ.questions = faqs;

export default FAQs;
